import { Currency } from '@core/constants/data-types.constants';
import { Product, ProductTemporalityCondition } from '@core/models/product.model';

export type TemporalityType = 'duration' | 'until';

export interface Temporality {
  id: string;
  value: number;
  type: TemporalityType;
}

export function convertTemporalityConditionToTemporality(
  temporalityCondition: ProductTemporalityCondition
): Temporality | undefined {
  if (temporalityCondition.then.ageLimit) {
    return {
      id: temporalityCondition.id,
      value: temporalityCondition.then.ageLimit,
      type: 'until'
    };
  }
  if (temporalityCondition.then.yearsDuration) {
    return {
      id: temporalityCondition.id,
      value: temporalityCondition.then.yearsDuration,
      type: 'duration'
    };
  }
  return undefined;
}

export function getProductAvailableTemporalities(product: Product, currency: Currency, age: number): Temporality[] {
  const temporalitiesMap = new Map<string, Temporality>();
  product.temporalityConditions
    .filter(p => p.if.currency === currency)
    .filter(p => p.if.minAge <= age && age < p.if.maxAge)
    .forEach(p => {
      const temporality = convertTemporalityConditionToTemporality(p);
      if (temporality) {
        temporalitiesMap.set(p.id, temporality);
      }
    });
  return Array.from(temporalitiesMap.values());
}
